var Util = require("../../lib/util.js");
var console = require("../../lib/logger.js");

console.info(__GLOBAL_LOG_PREFIX__, "^^^^^^^^^scout.js flow start.^^^^^^^");

if (Util.isSameWindow(window, window.top) === true) {

    require("./scout.topframe.js");
}

require("./scout.frame.js");

console.info(__GLOBAL_LOG_PREFIX__, "^^^^^^^^^scout.js flow done.^^^^^^^");
